<template>
  <div class="GlobalFormDemo">
    <GlobalForm
      :init-data="initData"
      :form-rules="formRules"
      :form-item-list="formItemList"
      :needBtnLoading="true"
      :inline="true"
      round
      @handleConfirm="handleConfirm"
      confirmBtnName="查询"
    >
      <div style="text-align: right; margin-bottom: 20px" slot="AddSlot">
        <!-- <el-button
          size="small"
          type="warning"
          icon="el-icon-plus"
          @click="report()"
          >批量导入</el-button
        > -->
        <!-- <el-button
          size="small"
          type="success"
          icon="el-icon-download"
          @click="exportTable()"
          >导出Excel</el-button
        > -->
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="handleBtn('add')"
          >新增广告</el-button
        >
      </div>
    </GlobalForm>

    <el-dialog
      class="add-dialog"
      title="导入门店"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="500px"
      @closed="handleDialogClosed"
    >
      <div class="step">
        <div class="step-title">
          <img
            src="@/assets/images/ico_ts_red.png"
            alt=""
            style="width: 18px; height: 18px; margin-right: 5px"
          />
          <span>温馨提示:请按模板表格严格填写，带*的为必填项。</span>
        </div>
        <div class="step-content">
          <el-button
            type="success"
            icon="el-icon-download"
            size="medium"
            @click="download"
            >下载数据模板</el-button
          >
        </div>
        <el-form
          ref="importForm"
          :model="importForm"
          :rules="importRules"
          label-width="80px"
        >
          <el-form-item label="表格上传" prop="fileName" class="fileName">
            <el-input
              v-model="importForm.fileName"
              @clear="fileClear"
              :disabled="true"
              size="medium"
              clearable
            >
            </el-input>
            <div style="float: right; position: relative">
              <el-button size="medium" type="warning" icon="el-icon-upload2"
                >上传表格</el-button
              >
              <input
                accept=".xls, .xlsx"
                ref="fileUpload"
                @change="onUploadList"
                type="file"
                style="
                  opacity: 0;
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  cursor: pointer;
                "
              />
            </div>
            <div style="color: #ff687b">
              仅支持.xls及.xlsx格式,单次上传大小不超过5M
            </div>
          </el-form-item>
        </el-form>
        <div class="step2-content"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click.native="uploadFile">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formValidateMobile } from "@/utils/form-validate";
import _api from "@/utils/request";
import {http} from "../../../utils/request/newIndex"
export default {
  name: "Form",
  data() {
    return {
      // 导入弹窗
      dialogVisible: false,
      seachParams: {},
      merchantId: "",
      importForm: {
        fileName: "",
      },
      storeId: "",
      importRules: {
        fileName: [
          {
            required: true,
            message: "仅支持.xls及.xlsx格式,单次上传大小不超过5M",
            trigger: "blur",
          },
        ],
      },
      paramsExcel: {},
      /////////////

      roleId: "",
      initData: null,
      formItemList: [
        {
          key: "adName",
          type: "input",
          labelName: "广告名称",
          placeholder: "请输入广告名称",
        },
        {
          key: 'entryTime',
          type: 'daterange',
          labelName: '创建时间',
          placeholder: '请选择创建时间',
          valueFormat:"timestamp"
        },
        { slot: "AddSlot" },
      ],
      formRules: {
        mobile: [
          {
            validator: formValidateMobile,
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    console.log(http,_api);
  },
  watch: {
    importForm(newVal) {
      console.log(newVal, "importForm");
      if (!this.importForm.fileName) {
        this.paramsExcel.file = "";
      }
    },
  },
  methods: {
    handleChange(val) {
      this.merchantId = val
      console.log(this.merchantId)
    },
    report() {
      this.dialogVisible = true;
    },
    handleBtn() {
      this.$router.push("/OnlinreyService/addAds")
    },
    //查询
    handleConfirm(data,cd) {
      console.log(data,"datatatata");
      if(data){
        if(data.entryTime===null){
          this.startTime="",
          this.endTime=""
        }else{
          this.startTime=data.entryTime[0],
          this.endTime=data.entryTime[1]
        }
      }else{
        this.startTime="",
        this.endTime=""
      }
      const SeachParams = {
        adName: data && data.adName?data.adName : "",
        startTime: data && this.startTime?this.startTime : "",
        endTime: data && this.endTime?this.endTime: "",
        pageNum: 1,
        pageSize: 10,
        disuseLoding: () => {
          if (typeof cd === 'function') {
            cd()
          }
        }
      };
      // this.seachParams = {
      //   adName: data && data.storeName?data.storeName : "",
      //   storeManager: data && data.storeManager?data.storeManager : "",
      //   storeManagerPhone: data && data.staffMobile?data.staffMobile : "",
      // };
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
    // 弹窗关闭
    handleDialogClosed() {
      if (this.$refs["addForm"]) {
        this.$refs["addForm"].resetFields();
      } else {
        this.$refs["importForm"].resetFields();
      }
      this.importForm = {
        fileName: "",
      };
      this.staffForm = {
        staffName: "",
        staffMobile: "",
        roleId: "",
        xcxStaffId: "",
        userAcc: "",
        userPwd: "",
        staffType: "",
      };
      this.$refs.fileUpload.value = "";
      this.paramsExcel = {};
      this.dialogVisible = false;
    },
    download() {
      const link = document.createElement("a");
      link.href = "/static/导入门店模板.xlsx";
      link.setAttribute("download", "导入门店模板.xlsx");
      document.body.appendChild(link);
      link.click();
    },
    onUploadList(event, type) {
      console.log(event);
      this.paramsExcel.file = event.target.files;
      if (this.paramsExcel.file.length) {
        this.paramsExcel.excelName = event.target.files[0].name;
        this.importForm.fileName = event.target.files[0].name;
      }
    },
    // 确定导出
    uploadFile() {
      if (!this.paramsExcel.file || this.paramsExcel.file.length == 0) {
        return this.$message.error("请上传表格");
      }
      const fd = new FormData();
      console.log(this.paramsExcel);
      fd.append("file", this.paramsExcel.file[0]); //文件
      console.log(fd);
      // 发起请求
      _api
        .inputStore(fd)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 1) {
            this.$store.commit("tagsView/STORE_EXCEL", "storeExcel");
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.importForm.fileName = "";
            this.$refs.fileUpload.value = "";
            this.dialogVisible = false;
          } else {
            this.$message({
              type: "warning",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.importForm.fileName = "";
          this.$refs.fileUpload.value = "";
        });
    },
    fileClear() {
      this.$refs.fileUpload.value = "";
      this.paramsExcel = {};
    },
    exportTable() {
      _api.exportStore(this.seachParams).then((res) => {
        console.log(res);
        const content = res;
        const blob = new Blob([content]);
        const fileName = "门店列表.xlsx";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {
  .step {
    .step-title {
      display: flex;
      color: #ff687b;
      margin-bottom: 18px;
    }
    .fileName {
      /deep/.el-input {
        width: 260px;
      }
    }
    .step-content {
      margin-bottom: 20px;
    }
  }
}
</style>
